import React, { useState, useEffect, useRef } from 'react'
import { NavLink, useHistory, useParams } from 'react-router-dom'
import { Game1Map, getRndFromArray, useStore } from '../lib'
import { Guide, Image as Img, Loader, ModalAlert, ScoreStats, SideNav } from '../components'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { GameFrame } from './GameFrame'

export const Game1 = () => {
  const [isInitialized, setIsInitialized] = useState<boolean>(false)
  const [isFinished, setIsFinished] = useState<boolean>(false)
  const [imgWidth, setImgWidth] = useState<number>((window.innerWidth * 0.495) / 2)
  const [allAnimals, setAllAnimals] = useState<any>(null)
  const [displayedAnimals, setDisplayedAnimals] = useState<any>(null)
  const [currentAnimal, setCurrentAnimal] = useState<any>(null)
  const [currentSound, setCurrentSound] = useState<any>(null)
  const [isPlaying, setIsPlaying] = useState<boolean>(false)
  const [errorA, setErrorA] = useState<boolean>(false)
  const [errorB, setErrorB] = useState<boolean>(false)
  const [errorC, setErrorC] = useState<boolean>(false)
  const [errorD, setErrorD] = useState<boolean>(false)
  const [successA, setSuccessA] = useState<boolean>(false)
  const [successB, setSuccessB] = useState<boolean>(false)
  const [successC, setSuccessC] = useState<boolean>(false)
  const [successD, setSuccessD] = useState<boolean>(false)
  const [gameStartTime, setGameStartTime] = useState<number>(+new Date())
  const [gameEndTime, setGameEndTime] = useState<number>()
  const history = useHistory()
  const refGuide: any = useRef(null)
  const refModal: any = useRef(null)
  // const { id }: any = useParams()
  const { state, patchState } = useStore()

  const preloadImages = async () => {
    const onImgLoad = async (imageEl: HTMLImageElement) => {
      return new Promise(resolve => {
        imageEl.onload = () => resolve(imageEl)
      })
    }
    const all = [...Game1Map.birds.data, ...Game1Map.mammals.data].map(a => a.img)
    for (const imgSrc of all) {
      const img = new Image()
      img.src = imgSrc
      await onImgLoad(img)
    }
    setIsInitialized(true)
    refGuide.current?.openModal(Game1Map.intro)
    return true
  }

  const selectDisplayedAnimals = () => {
    const birds = getRndFromArray(allAnimals.birds.data, 2)
    const mammals = getRndFromArray(allAnimals.mammals.data, 2)
    setDisplayedAnimals([...mammals, ...birds])
  }

  useEffect(() => {
    // console.warn({allAnimals, isInitialized, Game1Map}); // TODO: remove
    if (!allAnimals && !isFinished) {
      const all = JSON.parse(JSON.stringify(Game1Map))
      const birds = getRndFromArray(all.birds.data, 2)
      console.warn(birds)
      const mammals = getRndFromArray(all.mammals.data, 2)
      console.warn(mammals)
      setAllAnimals({ ...birds, ...mammals }) // vybrat 4 na zacatek, nemizet a nedoplnovat
      console.warn({ ...birds, ...mammals })
      // setAllAnimals(all)
      setDisplayedAnimals([...mammals, ...birds])
    } else if (allAnimals && !isInitialized) {
      preloadImages()
      // selectDisplayedAnimals()
      patchState({ score: 0, errors: 0 }) // todo
    }
  }, [allAnimals])

  useEffect(() => {
    // console.warn({displayedAnimals, isFinished, isInitialized, allAnimals}); // TODO: remove
    // if (displayedAnimals?.length > 0) {
    //   const a = getRndFromArray([...displayedAnimals])
    //   // console.warn(a, displayedAnimals); // TODO: remove
    //   const sound = new Audio(a.sound)
    //   setCurrentAnimal(a)
    //   setCurrentSound(sound)
    //   setIsPlaying(true)
    //   sound.play()
    //   sound.onended = () => setIsPlaying(false)
    // } else if (!!displayedAnimals && !displayedAnimals?.length && !isFinished) {
    //   setIsFinished(true)
    //   setGameEndTime(+new Date())
    //   const timeMs = +new Date() - gameStartTime
    //   patchState({ timeMs: state.timeMs + timeMs, games: { ...state.games, game1: { score: state.score, errors: state.errors, timeMs } } })
    //   // refModal?.current?.openModal([`Hotovo celek, score: ${state.score}, errors: ${state.errors}`])
    // }
  }, [displayedAnimals])

  useEffect(() => {
    return () => {
      currentSound?.pause()
    }
  }, [currentSound])

  const playSound = () => {
    currentSound?.play()
    setIsPlaying(true)
  }

  const stopSound = () => {
    currentSound?.pause()
    setIsPlaying(false)
  }

  const selectAnimal = (id: string) => {
    // console.warn(id); // TODO: remove
    const isValid = id === currentAnimal?.id
    if (isValid) {
      refGuide?.current?.openModal([currentAnimal.comment])
      patchState({ score: state.score + 1 })
    } else {
      patchState({ errors: state.errors + 1 })
    }
    let aIndex = 0
    for (const an of displayedAnimals) {
      if (an.id === id) {
        switch (aIndex) {
          case 0:
            if (isValid) {
              setSuccessA(true)
            } else {
              setErrorA(true)
              setTimeout(() => setErrorA(false), 2000)
            }
            break
          case 1:
            if (isValid) {
              setSuccessB(true)
            } else {
              setErrorB(true)
              setTimeout(() => setErrorB(false), 2000)
            }
            break
          case 2:
            if (isValid) {
              setSuccessC(true)
            } else {
              setErrorC(true)
              setTimeout(() => setErrorC(false), 2000)
            }
            break
          case 3:
            if (isValid) {
              setSuccessD(true)
            } else {
              setErrorD(true)
              setTimeout(() => setErrorD(false), 2000)
            }
            break
        }
      }
      aIndex++
    }
  }

  const onValidAnswer = () => {
    stopSound()
    let remainingAnimals = [...displayedAnimals]
    if (successA) {
      delete remainingAnimals[0]
    }
    if (successB) {
      delete remainingAnimals[1]
    }
    if (successC) {
      delete remainingAnimals[2]
    }
    if (successD) {
      delete remainingAnimals[3]
    }
    remainingAnimals = remainingAnimals.filter(a => !!a)
    if (remainingAnimals?.length > 0) {
      const a = getRndFromArray([...remainingAnimals])
      // console.warn(a, remainingAnimals); // TODO: remove
      const sound = new Audio(a.sound)
      setCurrentAnimal(a)
      setCurrentSound(sound)
      setIsPlaying(true)
      sound.play()
      sound.onended = () => setIsPlaying(false)
    } else if (!!remainingAnimals && !remainingAnimals?.length && !isFinished) {
      setIsFinished(true)
      setGameEndTime(+new Date())
      refGuide.current?.playSound()
      const timeMs = +new Date() - gameStartTime
      patchState({
        timeMs: state.timeMs + timeMs,
        games: { ...state.games, game1: { score: state.score, errors: state.errors, timeMs } },
      })
      refGuide?.current?.onGameEnd(state.errors)
      // refModal?.current?.openModal([`Hotovo celek, score: ${state.score}, errors: ${state.errors}`])
    }
    return
    // todo cleanup
    const id = currentAnimal?.id
    const nextBirds = allAnimals.birds.data.filter((a: any) => a.id !== id)
    const nextMammals = allAnimals.mammals.data.filter((a: any) => a.id !== id)
    const nextAllAnimals = { ...allAnimals }
    nextAllAnimals.birds.data = nextBirds
    nextAllAnimals.mammals.data = nextMammals
    const nextDisplayedAnimals = displayedAnimals.filter((a: any) => a.id !== id)
    const wasBird = allAnimals.birds.data.filter((a: any) => a.id === id).length > 0
    const nextDisplayedAnimalsIds = nextDisplayedAnimals.map((a: any) => a.id)
    const unusedBirds = nextBirds.filter((b: any) => !nextDisplayedAnimalsIds.includes(b.id))
    const unusedMammals = nextMammals.filter((b: any) => !nextDisplayedAnimalsIds.includes(b.id))
    if ((wasBird && unusedBirds.length > 0) || (!wasBird && unusedMammals.length > 0)) {
      nextDisplayedAnimals.push(getRndFromArray(wasBird ? unusedBirds : unusedMammals))
    } else {
      nextDisplayedAnimals.push(getRndFromArray(wasBird ? unusedMammals : unusedBirds))
    }
    Object.keys(nextDisplayedAnimals).forEach((k, i) => {
      if (nextDisplayedAnimals[k] === undefined) {
        nextDisplayedAnimals.splice(i, 1)
      }
    })

    // while (nextDisplayedAnimals.length < 4 && (wasBird ? nextBirds : nextMammals).length > 0) {
    //   const nextA = getRndFromArray([...(wasBird ? nextBirds : nextMammals)])
    //   if (!nextDisplayedAnimals.filter((a: any) => a.id === nextA.id).length) {
    //     nextDisplayedAnimals.push(nextA)
    //   }
    // }

    // let isUnique = Array.from(new Set([...nextDisplayedAnimals])).length === nextDisplayedAnimals.length
    // console.warn({isUnique}); // TODO: remove
    // while (!isUnique) { // todo
    //   nextDisplayedAnimals.push(getRndFromArray([...(wasBird ? nextBirds : nextMammals)]))
    //   isUnique = Array.from(new Set([...nextDisplayedAnimals])).length === nextDisplayedAnimals.length
    // }

    setAllAnimals(nextAllAnimals)
    setDisplayedAnimals(Array.from(new Set([...nextDisplayedAnimals])))
  }

  const exitGame = () => {
    setAllAnimals(null)
    setDisplayedAnimals(null)
    setCurrentAnimal(null)
    setIsInitialized(false)
    setTimeout(() => history.push('/dashboard'))
  }

  if (!isInitialized || !displayedAnimals) {
    return <Loader />
  }
  return (
    <div className="view background-winter">
      <div className="p-5 text-black view-content">
        <h1 className="text-3xl text-center font-bold w-full">Hlasy lesa</h1>
        <ScoreStats
          isCompact={true}
          isTimeShown={true}
          startTime={gameStartTime}
          endTime={gameEndTime}
          customScore={state.score}
          customErrors={state.errors}
        />
        <SideNav customScore={state.score} customErrors={state.errors} customText={Game1Map.intro} />
        <div style={{ zIndex: 99 }}>
          <Guide
            ref={refGuide}
            isWinter={true}
            hasWinterGearA={true}
            hasWinterGearB={true}
            onClose={() => (isFinished ? null : onValidAnswer())}
          />
        </div>
        <GameFrame
          isFinished={isFinished}
          onExit={exitGame}
          childrenLeft={
            <div className="w-full flex flex-col justify-between">
              <div className="flex flex-row justify-around pl-10 pr-10">
                <div
                  style={{
                    width: `${imgWidth}px`,
                    height: `${imgWidth * 0.95}px`,
                    maxHeight: `${(window.innerHeight - 100) / 2}px`,
                  }}
                >
                  {displayedAnimals?.length > 0 && (
                    <Img
                      src={displayedAnimals[0].img}
                      title={displayedAnimals[0].label}
                      width={`${imgWidth}px`}
                      hasError={errorA}
                      isCorrect={successA}
                      onClick={() => (successA ? null : selectAnimal(displayedAnimals[0].id))}
                      onLabelClick={() => (successA ? null : selectAnimal(displayedAnimals[0].id))}
                    />
                  )}
                </div>
                <div
                  style={{
                    width: `${imgWidth}px`,
                    height: `${imgWidth * 0.95}px`,
                    maxHeight: `${(window.innerHeight - 100) / 2}px`,
                  }}
                >
                  {displayedAnimals?.length > 1 && (
                    <Img
                      src={displayedAnimals[1].img}
                      title={displayedAnimals[1].label}
                      width={`${imgWidth}px`}
                      hasError={errorB}
                      isCorrect={successB}
                      onClick={() => (successB ? null : selectAnimal(displayedAnimals[1].id))}
                      onLabelClick={() => (successB ? null : selectAnimal(displayedAnimals[1].id))}
                    />
                  )}
                </div>
              </div>
              <div className="flex flex-row justify-around pl-10 pr-10">
                <div
                  style={{
                    width: `${imgWidth}px`,
                    height: `${imgWidth * 0.95}px`,
                    maxHeight: `${(window.innerHeight - 100) / 2}px`,
                  }}
                >
                  {displayedAnimals?.length > 2 && (
                    <Img
                      src={displayedAnimals[2].img}
                      title={displayedAnimals[2].label}
                      width={`${imgWidth}px`}
                      hasError={errorC}
                      isCorrect={successC}
                      onClick={() => (successC ? null : selectAnimal(displayedAnimals[2].id))}
                      onLabelClick={() => (successC ? null : selectAnimal(displayedAnimals[2].id))}
                    />
                  )}
                </div>
                <div
                  style={{
                    width: `${imgWidth}px`,
                    height: `${imgWidth * 0.95}px`,
                    maxHeight: `${(window.innerHeight - 100) / 2}px`,
                  }}
                >
                  {displayedAnimals?.length > 3 && (
                    <Img
                      src={displayedAnimals[3].img}
                      title={displayedAnimals[3].label}
                      width={`${imgWidth}px`}
                      hasError={errorD}
                      isCorrect={successD}
                      onClick={() => (successD ? null : selectAnimal(displayedAnimals[3].id))}
                      onLabelClick={() => (successD ? null : selectAnimal(displayedAnimals[3].id))}
                    />
                  )}
                </div>
              </div>
            </div>
          }
          childrenRight={
            isFinished ? null : (
              <button
                onClick={() => playSound()}
                className="btn glass text-black mb-5 btn-block"
                disabled={!currentSound || isPlaying}
              >
                {isPlaying ? 'Poslouchej ...' : 'Přehrát znovu'}
              </button>
            )
          }
        />
        {/*<div className="flex flex-row mt-5" style={{ width: '100%' }}>*/}
        {/*  <div style={{ width: 'auto' }}>*/}
        {/*    <div className="flex flex-row">*/}
        {/*      <div style={{ width: `${imgWidth}px` }}>*/}
        {/*        {displayedAnimals?.length > 0 && <Img src={displayedAnimals[0].img} title={displayedAnimals[0].label} width={`${imgWidth}px`} hasError={errorA} onClick={() => selectAnimal(displayedAnimals[0].id)} />}*/}
        {/*      </div>*/}
        {/*      <div style={{ width: `${imgWidth}px` }}>*/}
        {/*        {displayedAnimals?.length > 1 && <Img src={displayedAnimals[1].img} title={displayedAnimals[1].label} width={`${imgWidth}px`} hasError={errorB} onClick={() => selectAnimal(displayedAnimals[1].id)} />}*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*    <div className="flex flex-row">*/}
        {/*      <div style={{ width: `${imgWidth}px` }}>*/}
        {/*        {displayedAnimals?.length > 2 && <Img src={displayedAnimals[2].img} title={displayedAnimals[2].label} width={`${imgWidth}px`} hasError={errorC} onClick={() => selectAnimal(displayedAnimals[2].id)} />}*/}
        {/*      </div>*/}
        {/*      <div style={{ width: `${imgWidth}px` }}>*/}
        {/*        {displayedAnimals?.length > 3 && <Img src={displayedAnimals[3].img} title={displayedAnimals[3].label} width={`${imgWidth}px`} hasError={errorD} onClick={() => selectAnimal(displayedAnimals[3].id)} />}*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*  <div style={{ height: `${imgWidth * 2}px`, overflow: 'hidden', width: '600px' }}>*/}
        {/*    <TransitionGroup>*/}
        {/*      <CSSTransition*/}
        {/*        timeout={200}*/}
        {/*        classNames='fade'*/}
        {/*        key={`${(!currentSound || isPlaying)}_foo`}>*/}
        {/*        {!currentSound || isPlaying ? (*/}
        {/*          <div className="ml-5" style={{ height: `${imgWidth * 2}px`, overflow: 'hidden', width: '315px' }}>*/}
        {/*            <button onClick={() => playSound()} className="btn btn-block text-black mb-5" disabled={!currentSound || isPlaying}>{isPlaying ? 'listen ...' : 'replay'}</button>*/}
        {/*            <p className="text-2xl text-left">*/}
        {/*              Lesník na úvod řekne:*/}
        {/*              <br/>*/}
        {/*              V lese se ozývají desítky různých hlasů. Poznáš, který hlas patří kterému zvířeti?*/}
        {/*              <br/><br/>*/}
        {/*              Zadání úkolu:*/}
        {/*              <br/>*/}
        {/*              Označ obrázek zvířete, kterému patří tento hlas. Kliknutím na magnetofon si můžeš hlas zopakovat.*/}
        {/*            </p>*/}
        {/*          </div>*/}
        {/*        ) : (*/}
        {/*          <div className="ml-5" style={{ height: `${imgWidth * 2}px`, overflow: 'hidden', width: '315px' }}>*/}
        {/*            <button onClick={() => playSound()} className="btn btn-block text-black mb-5" disabled={!currentSound || isPlaying}>{isPlaying ? 'listen ...' : 'replay'}</button>*/}
        {/*          </div>*/}
        {/*        )}*/}
        {/*      </CSSTransition>*/}
        {/*    </TransitionGroup>*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div>
          <ModalAlert ref={refModal} onClose={() => null} />
        </div>
      </div>
    </div>
  )
}
